import { Input } from "@rebass/forms";

export default Input;
